const exportDsPdf = async ({ boxes, resolvedValues = {}, userValues = {}, metadata = {}, onProgress }) => {
  try {
    if (onProgress) onProgress('Generating PDF…');

    const dsName   = metadata.dsName || 'datasheet';
    const filename = `ISA-${dsName}.pdf`.replace(/[/\\?%*:|"<>]/g, '-');

    let fileHandle = null;
    if (window.showSaveFilePicker) {
      try {
        fileHandle = await window.showSaveFilePicker({
          suggestedName: filename,
          types: [{ description: 'PDF Document', accept: { 'application/pdf': ['.pdf'] } }],
        });
      } catch (err) {
        if (err.name === 'AbortError') {
          if (onProgress) onProgress(null);
          return false;
        }
      }
    }

    const blob = await new Promise((resolve, reject) => {
      const worker = new Worker(new URL('../../workers/dsPdfWorker.js', import.meta.url));
      worker.onmessage = ({ data: result }) => {
        worker.terminate();
        if (result.type === 'done') resolve(result.blob);
        else reject(new Error(result.message || 'PDF worker failed'));
      };
      worker.onerror = (err) => { worker.terminate(); reject(err); };
      worker.postMessage({ boxes, resolvedValues, userValues, metadata });
    });

    if (fileHandle) {
      try {
        const writable = await fileHandle.createWritable();
        await writable.write(blob);
        await writable.close();
      } catch { fileHandle = null; }
    }

    if (!fileHandle) {
      const url = URL.createObjectURL(blob);
      const a   = document.createElement('a');
      a.href     = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }

    if (onProgress) onProgress(null);
    return true;
  } catch (err) {
    if (onProgress) onProgress(null);
    throw err;
  }
};

export default exportDsPdf;
